// extracted by mini-css-extract-plugin
export default {"myStocks":"index_myStocks_CbWOQ","box":"index_box_lDOTN","login":"index_login_9NuBc","add":"index_add_5CB2k","tip":"index_tip_p70gh"};